<div>
  <img
    id="six-arts-logo"
    class="top-padding"
    src="assets/images/six_arts_logo_long.png"
    routerLink="/six-arts"
  />

  <div style="text-align: left;">
    <p id="back-link">
      <a routerLink="/six-arts">返回</a>
    </p>
  </div>
</div>

<hr>

<h1 class="display-4">Add Class</h1>
<form #form="ngForm" autocomplete="off" (submit)="onSubmit(form)">

<div class="form-row">
    <div class="form-group col-md-3">
      <input  name="id" #id="ngModel" [(ngModel)]="service.formData.id" class="form-control" placeholder="ID#" standalone=true>
      <label>Class ID</label>
    </div>
    <div class="form-group col-md-3">
      <input name="name" #name="ngModel" [(ngModel)]="service.formData.name" class="form-control" placeholder="Course name" standalone=true>
      <div *ngIf="name.invalid && name.touched" class="validation-error">This field is required.</div>
      <label>Course Name</label>
    </div>
    <!-- <div class="form-group  col-md-6">
      <input type="color" #color="ngModel" [(ngModel)]="service.formData.color" class="form-control" value="#ff0000" style="width:50%;">
    </div> -->
    <!-- <div class="form-group col-md-3">
      <input [(colorPicker)]="color" [(ngModel)]="service.formData.color"
      [cpAlphaChannel]="'disabled'" name="color" [value]="color" [style.background]="color"/>
      <label>Course Color</label>

    </div> -->


  </div>

  <div class="form-row">
    <div class="form-group col-md-6">
      <select name="day" #day="ngModel" [(ngModel)]="service.formData.day" class="form-control" placeholder=1>
        <option value="MON">星期一</option>
        <option value="TUE">星期二</option>
        <option value="WED">星期三</option>
        <option value="THUR">星期四</option>
        <option value="FRI">星期五</option>
      </select>
      <label>星期</label>
    </div>
    <div class="form-group col-md-2">
      <input type="time" name="times" #time="ngModel" [(ngModel)]="service.formData.times" class="form-control" placeholder="Time">
      <label for="default-picker">Time Start</label>
    </div>
    -
    <div class="form-group col-md-2">
      <input type="time" name="timee" #time="ngModel" [(ngModel)]="service.formData.timee" class="form-control" placeholder="Time">
      <label for="default-picker">Time End</label>
    </div>
  </div>
  <div class="form-group">
    <input name="dayt" #dayt="ngModel" [(ngModel)]="service.formData.dayt" class="form-control" placeholder="逢星期一 (共6堂)">
    <label>日期</label>
  </div>
  <div class="form-group">
    <input name="timet" #timet="ngModel" [(ngModel)]="service.formData.timet" class="form-control" placeholder="上午9時30分至11時">
    <label>時間</label>
  </div>
  <div class="form-group">
    <textarea name="description" #description="ngModel" [(ngModel)]="service.formData.description" class="form-control" placeholder="內容">
    </textarea>
    <label>內容</label>
  </div>
  <div class="form-group">
    <textarea name="teacher" #teacher="ngModel" [(ngModel)]="service.formData.teacher" class="form-control" placeholder="導師">
    </textarea>
    <label>導師</label>
  </div>
  <div class="form-group">
    <input name="tuition" #tuition="ngModel" [(ngModel)]="service.formData.tuition" class="form-control" placeholder="學費">
    <label>學費</label>
  </div>

  <input class="form-group" type="file" accept="image/*" (change)="showPreview($event)" /> {{ uploadPercent | async }}
    <div>
    <!-- <a [href]="upload.downloadURL | async">{{ upload.downloadURL | async }}</a> -->
    <img
        [src]="imageUrl"
      />
    </div>



  <div class="form-group">
    <button type="submit" [disabled]="form.invalid" class="btn btn-lg btn-block btn-info">SUBMIT</button>
  </div>

</form>


